module.exports = `
<%
var seats = new Set(data.candidates.map(c => c.seat));
%>
<div class="home view">
  <h3 data-focus tabindex="-1"><span class="sr-only">List of</span> Candidates</h3>
  <hr>
  <div class="district-container">
  <% for (var d of [...seats].sort()) { %>
    <div class="district">
    <h4>District <%= d %></h4>
    <ul class="people">
      <% data.candidates.filter(c => c.seat == d).forEach(function(c) { %>
      
        <li> 
          <a 
            <% if (c.responded) { %> href="#/candidate/<%= c.short %>" <% } %>
          >

          <!-- mugshot or blank photo -->
          <% if (c.photo) { %>
            <img alt="" class="mug" src="./assets/<%= c.photo %>">
          <% } else { %>
            <div class="mug placeholder"></div>
          <% } %>

          <!-- candidate name and party info -->

          <%= c.name %>
          <span class="party">
            <%= c.party_short ? "<br>(" + c.party_short + ")" : '' %>
            <% if (c.incumbent) { %>
              <span class="incumbent">*</span>
            <% } %> 
          </span>
          
          <!-- flag for 0 responses -->
          <br> 
          <% if (!c.responded) { %>
            <i>No response</i>
          <% } %>

          </a>
        </li>
      <% }); %>
    </ul>
  </div>
  <% } %>
  </div>

  <h3>Questions</h3>
  <hr>
  <% if (data.questions.filter(q => q.reader).length) { %>
  <div class="subhed">Reader-submitted questions are indicated with &#128172;</i></div>
  <% } %>
  <ul class="questions">
    <% data.questions.forEach(function(q) { %>
    <li> 
      <a href="#/question/<%= q.short %>"><%= q.question.trim() %></a>
      <% if (q.reader) { %>
        <span> &#128172; </span> 
      <% } %>  
    </li>
    <% }); %>
   
  </ul>
</div>
`